import React, { useState } from 'react';
import { MenuItem, Select, Input, InputLabel, FormControl, ListItemIcon } from '@mui/material';

import { COUNTRIES } from '../contries/contries'; // Importando a lista de países

const CountrySelect = ({ onChange, value }) => {
    const [selectedCountry, setSelectedCountry] = useState(value || 'BR');

    const handleCountryChange = (event) => {
        setSelectedCountry(event.target.value);
        onChange(event.target.value); // Chamando a função onChange do componente pai, se necessário
    };

    return (
        <FormControl fullWidth variant="outlined" margin="dense" style={{ marginTop: 8 }}>
            <InputLabel id="country-select-label">País</InputLabel>
            <Select
                labelId="country-select-label"
                id="country-select"
                value={selectedCountry}
                onChange={handleCountryChange}
                input={<Input />}
            >
                {COUNTRIES.map((country) => (
                    <MenuItem key={country.value} value={country.value}>
                       
                            <img width={24} style={ { margin: '0px 8px'}}
                                alt={country.title}
                                src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country.value}.svg`}
                                className={"inline mr-2 h-4 rounded-sm"}
                            />
                        {country.title}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CountrySelect;
